<template>
  <zm-drawer :title="title" :width="drawerWidth" :visible="visible" size="large" @cancel="open(false)" :footer="false">
    <div slot="drawerBody">
      <a-form :form="form">
        <div class="title">合同详情</div>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同名称">
              <a-input
                placeholder="请输入合同名称"
                id="name"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-decorator="['name', { rules: [{ required: true, message: '请输入合同名称！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同编号">
              <a-input
                placeholder="请输入合同编号"
                id="number"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-decorator="['number', { rules: [{ required: true, message: '请输入合同编号！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目名称">
              <a-select
                :allowClear="true"
                placeholder="请选择项目名称"
                :disabled="!isEdit"
                v-decorator="['projectName', { rules: [{ required: true, message: '请选择项目名称！' }] }]"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="甲方名称">
              <a-select
                :allowClear="true"
                placeholder="请选择甲方名称"
                :disabled="!isEdit"
                v-decorator="['partyName', { rules: [{ required: true, message: '请选择甲方名称' }] }]"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="内容类型">
              <a-select
                :allowClear="true"
                placeholder="请选择内容类型"
                :disabled="!isEdit"
                v-decorator="[
                  'contractContentDesc',
                  {
                    rules: [{ required: true, message: '请选择内容类型！' }],
                  },
                ]"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="签约日期">
              <a-date-picker
                :disabled="!isEdit"
                style="width: 100%"
                placeholder="请选择签约日期"
                v-decorator="['contractDate', { rules: [{ required: true, message: '请选择签约日期！' }] }]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="维护期限">
              <a-select
                :allowClear="true"
                placeholder="请选择维护期限"
                :disabled="!isEdit"
                v-decorator="[
                  'maintainDeadLineDesc',
                  {
                    rules: [{ required: true, message: '请选择质保期限！' }],
                  },
                ]"
              >
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="验收日期">
              <a-date-picker
                :disabled="!isEdit"
                style="width: 100%"
                placeholder="请选择验收日期"
                v-decorator="['checkDate', { rules: [{ required: true, message: '请选择验收日期！' }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="经办人">
              <a-select
                :allowClear="true"
                placeholder="请选择经办人"
                :disabled="!isEdit"
                v-decorator="[
                  'operatorName',
                  {
                    initialValue: model.operatorId,
                    rules: [{ required: true, message: '请选择经办人！' }],
                  },
                ]"
              >
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="合同金额">
              <a-input
                placeholder="请输入合同金额"
                id="contractAmount"
                autocomplete="off"
                :allowClear="true"
                :disabled="!isEdit"
                v-decorator="['contractAmount', { rules: [{ required: true, message: '请输入合同金额！' }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-divider style="margin: 16px 0"></a-divider>
        <div class="title">产品信息</div>
        <!-- 此处循环 contractSaleProductList-->
        <div v-for="(item1 , index1) in model.contractSaleProductList" :key="index1+'ff'">
          <a-row>
            <a-col :span="6">
              <a-form-item
                :labelCol="{ xs: { span: 24 }, sm: { span: 8 } }"
                :wrapperCol="{ xs: { span: 24 }, sm: { span: 15 } }"
                label="产品名称"
              >
                <a-select
                  :allowClear="true"
                  placeholder="请选择产品名称"
                  v-decorator="[
                    `productId[${item1}]`,
                    {
                      initialValue: item1.productName,
                      rules: [{ required: true, message: '请选择产品' }],
                    },
                  ]"
                  :disabled="!isEdit"
                >
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item
                :labelCol="{ xs: { span: 24 }, sm: { span: 8 } }"
                :wrapperCol="{ xs: { span: 24 }, sm: { span: 15 } }"
                label="产品总价"
              >
                <a-input
                  placeholder="请输入产品总价"
                  id="ArrNameNum"
                  autocomplete="off"
                  :allowClear="true"
                  v-decorator="[
                    `productPrice[${item1}]`,
                    {
                      initialValue: item1.productPrice,
                      rules: [{ required: true, message: '请输入产品总价！' }],
                    },
                  ]"
                  :disabled="!isEdit"
                />
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item
                :labelCol="{ xs: { span: 24 }, sm: { span: 4 } }"
                :wrapperCol="{ xs: { span: 24 }, sm: { span: 19 } }"
                label="功能模块"
              >
                <a-select
                  :allowClear="true"
                  placeholder="请选择功能模块"
                  mode="multiple"
                  v-decorator="[
                    `modelId[${item1}]`,
                    {
                      initialValue: handleArr(item1.modules),
                      rules: [{ required: true, message: '请选择功能模块' }],
                    },
                  ]"
                  :disabled="!isEdit"
                >
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </div>

        <!-- 此处循环  contractSalePaymentList-->
        <a-divider style="margin: 16px 0"></a-divider>
        <div class="title">收款方式</div>
        <div v-for="(item , index) in model.contractSalePaymentList" :key="index">
          <a-row>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="款项类型">
                <a-select
                  :allowClear="true"
                  placeholder="请选择款项类型"
                  v-decorator="[
                    `paymentDesc[${item}]`,
                    {
                      initialValue: item.paymentDesc,
                      rules: [{ required: true, message: '请选择款项类型' }],
                    },
                  ]"
                  :disabled="!isEdit"
                >Desc

                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计划收款">
                <a-date-picker
                  style="width: 100%"
                  placeholder="请选择计划收款"
                  v-decorator="[
                    `collectionDate[${item}]`,
                    {
                      initialValue: momentDate(item.collectionDate),
                      rules: [{ required: true, message: '请选择计划收款' }],
                    },
                  ]"
                  :disabled="!isEdit"
                />
              </a-form-item>
            </a-col>
            <a-col :span="colSpan">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收款比例">
                <a-input
                  placeholder="请输入收款比例"
                  autocomplete="off"
                  :allowClear="true"
                  addon-after="%"
                  v-decorator="[
                    `collectionRatio[${item}]`,
                    {
                      initialValue: Ratio(item.collectionRatio),
                      rules: [{ required: true, message: '请输入收款比例' }],
                    },
                  ]"
                  :disabled="!isEdit"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <a-divider style="margin: 16px 0"></a-divider>
        <div class="title">附件上传</div>
        <a-row>
          <a-col :span="24">
            <a-form-item
              label="合同附件"
              :labelCol="{ xs: { span: 24 }, sm: { span: 2 } }"
              :wrapperCol="{ xs: { span: 24 }, sm: { span: 22 } }"
            >
              <zm-preview
                :list="fileList"
                :baseUrl="$sysInfo.apiRemote"
                :previewUrl="$sysInfo.previewUrl"
                :account="$sysInfo.previewAccount"
                :token="$sysInfo.previewToken"
                :jwtToken="$store.state.user.token"
                downloadUrl="/contract/sale/export/"
              ></zm-preview>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-drawer>
</template>

<script>
import moment from 'moment'
import productModal from './loopModal/productModal'
import collectionModal from './loopModal/collectionModal'
import { mapState } from 'vuex'
export default {
  name: 'editPurchases',
  mounted() {
  },
  computed: {
    isEdit() {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    drawerWidth() {
      const width = window.innerWidth - 200
      return width
    },
    ...mapState({}),
  },
  components: {
    productModal,
    collectionModal,
  },
  data() {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'purchases' }),
      visible: false,
      defaultModel: {},
      model: {},
      modelListId: NaN,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      labelCol3: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol3: {
        xs: { span: 24 },
        sm: { span: 19 },
      },
      colSpan: 6,
      headers: {
        Authorization: this.$store.state.user.token,
      },
      fileList: [],
      isProductNameChange: false,
    }
  },
  methods: {
    // 设置类型
    setType(type) {
      this.type = type
    },
    // 设置标题
    setTitle(title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel(model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open(flag) {
      this.visible = flag
      if (this.type === this.$sysInfo.MODAL_MODIFY || this.type === this.$sysInfo.MODAL_VIEW) {
        if (flag) {
          this.$nextTick(() => {
            console.log('form值:', this.form.getFieldsValue())
            this.form.setFieldsValue({
              name: this.model.name,
              number: this.model.number,
              projectName: this.model.projectName,
              partyName: this.model.partyName,
              contractContentDesc: this.model.contractContentDesc,
              contractDate: moment(this.model.contractDate),
              maintainDeadLineDesc: this.model.maintainDeadLineDesc,
              checkDate: moment(this.model.checkDate),
              operatorName: this.model.operatorName,
              contractAmount: this.model.contractAmount,
            })
            this.fileList = this.model.contractSaleFileList
            console.log('token!!!',this.$store.state.user.token,"token",this.$sysInfo.previewToken);
          })
        }
      }
    },
    handleArr(value){
      const arr = []
      value.forEach((item,i)=>{
          if(item.moduleId){
              arr.push(item.moduleName)
          }
      })
      return arr
    },
    Ratio(val){
      return Number(val)*100
    },
    momentDate(val){
      return moment(val)
    },
  },
}
</script>

<style scoped lang="less">
.title {
  font-weight: bold;
  margin-bottom: 10px;
}
.title::before {
  display: inline-block;
  width: 4px;
  height: 12px;
  background: #1791ff;
  content: '';
  margin-right: 7px;
}
</style>

